
function customAccordion() {
  const accordion = document.querySelector('.js-custom-accordion');
  if(!accordion) return;
  const allHeaders = [...accordion.querySelectorAll('.accordion_title')];
  const activeAccordionClass = 'js-active-accordion';

  allHeaders.forEach(header => header.addEventListener('click', e => {
    const header = e.target.closest('.accordion_title');
    if(!header) return;

    if(header.classList.contains(activeAccordionClass)) {
      header.classList.remove(activeAccordionClass);
      header.setAttribute('aria-selected', 'false');
      header.setAttribute('aria-expanded', 'false');
      header.nextElementSibling.setAttribute('aria-hidden', 'true');
    } else {
      header.classList.add(activeAccordionClass);
      header.setAttribute('aria-selected', 'true');
      header.setAttribute('aria-expanded', 'true');
      header.nextElementSibling.setAttribute('aria-hidden', 'false');
    }
  }))
}

customAccordion();
